import React from 'react'
import { Box, CardMedia, Grid, Skeleton } from '@mui/material'
import ArticleSummary from './article-summary'
import ArticleCardContainer from './article-card-container'
import makeStyles from '@mui/styles/makeStyles'
import { image } from '../../placeholder'
import { getContentImageUrl } from '../../../helpers/content-image'

// PENG-3630: the thumbnail is 16:9 like every other content thumbnail, and
// sits 16px from the card's top, left and bottom: the card is as tall as the
// image plus its padding, so the compact summary beside it keeps to one line
// per row.
const IMAGE_WIDTH = 128
const IMAGE_HEIGHT = 72

export const useStyles = makeStyles(({ spacing, radius }) => ({
  image: {
    width: IMAGE_WIDTH,
    height: IMAGE_HEIGHT,
    borderRadius: radius.lg,
    flexShrink: 0
  },
  withImage: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(2)
  },
  summary: {
    flex: 1,
    minWidth: 0
  }
}))

const ArticleCard = ({ onSelect, article, showImage = true }) => {
  const classes = useStyles()

  if (!showImage) {
    return (
      <ArticleCardContainer article={article} onSelect={onSelect}>
        <Grid container wrap='nowrap' alignItems='center' spacing={3}>
          <Grid container item>
            <ArticleSummary article={article} subtitleLines={3} />
          </Grid>
        </Grid>
      </ArticleCardContainer>
    )
  }

  return (
    <ArticleCardContainer article={article} onSelect={onSelect}>
      <Box className={classes.withImage}>
        {article
          ? <CardMedia
              image={getContentImageUrl(article.image, { width: IMAGE_WIDTH * 2, height: IMAGE_HEIGHT * 2, fallback: image })}
              title='alt text here'
              className={classes.image}
              data-test={`article-card-image-${article?.friendlyUrl}`}
            />
          : <Skeleton variant='rectangular' className={classes.image} />}
        <ArticleSummary article={article} compact className={classes.summary} />
      </Box>
    </ArticleCardContainer>
  )
}

export default ArticleCard
